import { render, staticRenderFns } from "./ShirLastLogs.vue?vue&type=template&id=b7f77310&"
import script from "./ShirLastLogs.vue?vue&type=script&lang=js&"
export * from "./ShirLastLogs.vue?vue&type=script&lang=js&"
import style0 from "./ShirLastLogs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports